
<ng-container *ngIf="isNewFunnelLandingVariation$ | async; else legacyLandingPage">
  <!-- new landing page -->
  <flo-landing-page
    [heroContent]="heroContent$ | async"
    [logoContent]="logoContent$ | async"
    [offers]="offers$ | async"
    (offerSelected)="handleOfferSelected($event)"
    (loginButtonClicked)="handleLoginButtonClicked()"
    (signUpButtonClicked)="handleSignUpButtonClicked()"
    [siteSettings]="siteSettings$ | async"
    [isPlansVariation] = "isNewFunnelLandingVariation2$ | async"
    [siteSettings]="siteSettings$ | async"
    [liveEventHeader]="liveEventHeader$ | async"
  ></flo-landing-page>
</ng-container>

<!-- legacy landing page -->
<ng-template #legacyLandingPage>
  <flo-landing-page-legacy 
    [landingPageProps]="landingPageProps$ | async" 
    [carouselBackgroundGen]="carouselGen(false)"
    [carouselData]="carouselData$ | async">
  </flo-landing-page-legacy>
</ng-template>
